import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useFetch from "../../../../../services/functions/useFetch";
import deleteIcon from "../../../../../assets/icons/delete.svg";
import snowflake from "../../../../../assets/icons/loading-snowflake.svg";
import CustomAlert from "../../../../CustomAlert";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function DeleteContent() {
  const query = useQuery();
  const [id, setId] = useState<string | null>(null);
  const { error, isPending, fetchData } = useFetch();

  const navigate = useNavigate();

  useEffect(() => {
    setId(query.get("id"));
  }, [query]);

  const handleDelete = (id: string | null) => {
    if (!id) {
      console.error("Failed to delete exercise. Invalid ID!");
      return;
    }

    const payload = {
      id: Number(id),
    };

    fetchData(`/delete/exercise`, "DELETE", {
      body: payload,
      doOnSuccess: () => {
        navigate(-1);
      },
      doOnError: () => {
        console.error("Failed to delete exercise.");
      },
    });
  };

  return (
    <>
      {error && <CustomAlert message={error} type="error" />}
      {isPending ? (
        <img src={snowflake} alt="loading" className="loading-snowflake" />
      ) : (
        <>
          <div>Delete exersice with id {id}?</div>

          <img
            src={deleteIcon}
            alt="delete"
            className=""
            onClick={() => handleDelete(id)}
          />
        </>
      )}
    </>
  );
}

export default DeleteContent;
